import styled from "styled-components";
import { device } from "../../utils/device";

export const Container = styled.div`
  min-width: 20vw;
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  background-color: white;
  z-index: 10;
  max-height: 70vh;
  overflow: auto;
`;

export const Title = styled.p`
  font-family: "DM Sans";
  font-weight: 500;
  color: #123051;
  font-size: 16px;
`;

export const Description = styled.div`
  font-size: 14px;

  margin: 0;

  /* Ensure list formatting is preserved */
  ul {
    padding-left: 20px;
    margin-bottom: 0;
    list-style-type: disc;
  }

  ol {
    padding-left: 20px;
    margin-bottom: 0;
    list-style-type: decimal;
  }

  li {
    display: list-item;
    list-style-position: outside;
  }

  /* Preserve paragraph spacing in lists */
  p {
    margin-bottom: 0;
  }

  h1 {
    font-size: 16px;
    margin-bottom: 0;
  }
`;

export const LearnMoreButton = styled.button`
  font-family: "DM Sans";
  font-weight: 500;
  font-size: 12px;
  color: #123051;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
`;

export const MoreContent = styled.div`
  max-height: ${(props) => (props.show ? "100px" : "0")};
  overflow-y: auto;
  transition: max-height 0.3s ease;
  font-family: "DM Sans";
  font-weight: 400;
  font-size: 12px;
  color: #565556;
`;

export const StatsContainer = styled.div`
  padding: 8px;
  width: 100%;
  border-radius: 8px;
  background-color: #cca3cf26;
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

  @media (${device.mobileLandscape}) {
    display: none;
  }
`;

export const Stat = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  &:not(:last-child) {
    border-right: 1px solid #f5daf7;
  }
`;

export const StatText = styled.span`
  font-family: "DM Sans";
  font-weight: 500;
  font-size: 15px;
  color: #123051;
  text-align: center;
  margin-left: 5px;
`;

export const StatIcon = styled.img`
  height: 16px;
  width: 16px;
`;
